/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});function c(t,e,n,i){if(t){const a={syntheticEvent:e,nativeEvent:e.nativeEvent,target:n};t.call(void 0,Object.assign(a,i))}}exports.dispatchEvent=c;
